import { KnowledgeDocument } from '@/types/knowledge';
import { Badge } from '@/components/ui/badge';
import { Card, CardHeader, CardTitle, CardDescription, CardContent } from '@/components/ui/card';
import { FileText } from 'lucide-react';

interface DocumentCardProps {
  document: KnowledgeDocument;
  onClick: () => void;
}

export function DocumentCard({ document, onClick }: DocumentCardProps) {
  const statusColors = {
    draft: 'bg-gray-500',
    published: 'bg-green-500',
    deprecated: 'bg-red-500',
  };

  return (
    <Card
      className="cursor-pointer hover:shadow-md transition-shadow"
      onClick={onClick}
    >
      <CardHeader>
        <div className="flex items-start justify-between">
          <div className="flex items-center gap-2">
            <FileText className="h-5 w-5 text-muted-foreground" />
            <CardTitle className="text-lg">{document.title}</CardTitle>
          </div>
          <Badge className={statusColors[document.status]}>
            {document.status}
          </Badge>
        </div>
        <CardDescription>{document.category}</CardDescription>
      </CardHeader>
      <CardContent>
        <p className="text-sm text-muted-foreground line-clamp-2">
          {document.problem}
        </p>
        <div className="mt-2 text-xs text-muted-foreground">
          Versão {document.currentVersion} • {document.sourceProtocols.length} tickets
        </div>
      </CardContent>
    </Card>
  );
}
